import { render, staticRenderFns } from "./ReceivedMailShow.vue?vue&type=template&id=00f72f44&scoped=true&"
import script from "./ReceivedMailShow.vue?vue&type=script&lang=js&"
export * from "./ReceivedMailShow.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedMailShow.vue?vue&type=style&index=0&id=00f72f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f72f44",
  null
  
)

export default component.exports